<template>
  <v-container
    class="cmp-settings-accounting-sidewindow dt-sidewindow submodule-root"
  >
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="accountingSettingsTabs" tabPanelColor="secondary">
        <gtab id="accounting" :showTabTitle="false">
          <grow>
            <gcol>
              <gbox
                :title="$t('cost_group')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.cost_groups &&
                      accountingSettingsData.cost_groups.length
                  )
                "
              >
                <DTable
                  v-if="accountingSettingsData"
                  :linkLabelName="`${$t('add')} ${$t('cost')} ${$t(
                    'ps_cost_group'
                  )}`"
                  :items="
                    accountingSettingsData
                      ? accountingSettingsData.cost_groups
                      : []
                  "
                  :headers="groupHeader"
                  :showHeader="true"
                  :itemName="'Cost Group'"
                  :primaryKey="'cost_group_id'"
                  :labelKey="'cost_group_name'"
                  :fieldKey="'cluster'"
                  :fieldPlaceholder="'Cluster'"
                  @add_click="onCostGroupAddClick"
                  @changed="onCostGroupChange"
                  @selected="onCostGroupSelected"
                  @deleted="onCostGroupDeleted"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('income_group')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.income_groups &&
                      accountingSettingsData.income_groups.length
                  )
                "
              >
                <DTable
                  v-if="accountingSettingsData"
                  :linkLabelName="$t('add_income_group')"
                  :items="
                    accountingSettingsData
                      ? accountingSettingsData.income_groups
                      : []
                  "
                  :headers="groupHeader"
                  :showHeader="true"
                  :itemName="$t('income_group')"
                  :primaryKey="'cost_group_id'"
                  :labelKey="'cost_group_name'"
                  :fieldKey="'cluster'"
                  :fieldPlaceholder="'Cluster'"
                  @add_click="onIncomeGroupAddClick"
                  @changed="onIncomeGroupChanged"
                  @selected="onIncomeGroupSelected"
                  @deleted="onIncomeGroupDeleted"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="taxes">
          <grow>
            <gcol>
              <gbox
                :title="$t('tax_types')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.tax_types &&
                      accountingSettingsData.tax_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <TaxTypeList
                  v-if="accountingSettingsData"
                  :accountingSettingsData="accountingSettingsData"
                  @add_click="onTaxTypeAddClick"
                  @edit_click="onTaxTypeEditClick"
                  @delete_click="onTaxTypeDeleteClick"
                  @changed="onTaxTypeChange"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('tax_groups')"
                :titleIcon="'static/icons/help.svg'"
                :titleIconText="$t('tax_group_info')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.tax_groups &&
                      accountingSettingsData.tax_groups.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <DBox
                  v-if="accountingSettingsData"
                  :id="'settings-accounting-tax_groups'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="$t('add_tax_group')"
                  @add_click="onAddTaxGroupClick"
                >
                  <TaxGroups
                    :accountingSettingsData="accountingSettingsData"
                    :selectedTaxGroup="selectedTaxGroup"
                    @selected="onTaxGroupSelected"
                    @delete="onTaxGroupDelete"
                  />
                </DBox>
              </gbox>
              <!-- :h="boxHeight(tax_group_items && tax_group_items.length)" -->
              <gbox
                :title="$t('tax_group_items_drag_drop')"
                :h="
                  tax_group_items && tax_group_items.length > 0
                    ? boxHeightNamed({
                        rowCount: tax_group_items && tax_group_items.length,
                        offset:
                          tax_group_items.length > 0
                            ? NTOffsets.default
                            : NTOffsets.default + 64,
                        min: 1,
                      })
                    : 34 + 96
                "
              >
                <DBox
                  v-if="accountingSettingsData"
                  :id="'settings-accounting-tax_group_items'"
                  :addButton="false"
                >
                  <Ddropzone
                    :loadingFlag="tax_group_items_loading"
                    :info="dropZoneInfo"
                    @drop="onTaxGroupItemDrop"
                  >
                    <!-- <div class="cmp-settings-accounting-tax_group_items"> -->
                    <NTable
                      :id="'settings-accounting-tax_group_items'"
                      class="h2 dbox1"
                      :headers="taxGroupItemsTb"
                      :items="tax_group_items"
                      :config="
                        createNTableConfig({
                          rowHeight: 32,
                          fullHeight: true,
                          showHeader: false,
                        })
                      "
                      :showNoItems="false"
                    >
                      <template v-slot:item="{ item, tdcon }">
                        <tr>
                          <td v-bind="tdcon('tax_name')">
                            <span>{{ item.tax_name }}</span>
                          </td>
                          <td v-bind="tdcon('tax_rate_percent')">
                            <span>{{ item.tax_rate_percent }}%</span>
                          </td>
                          <td v-bind="tdcon('options')">
                            <div class="dt-icon-container">
                              <img
                                v-if="item.tax_relation_id"
                                src="static/icons/delete.svg"
                                class="dt-icon v5 s2"
                                @click="(e) => onDeleteTaxGroupItem(item)"
                                :alt="$t('remove_tax_group_item')"
                                :title="$t('remove_tax_group_item')"
                              />
                            </div>
                          </td>
                        </tr>
                      </template>
                    </NTable>
                    <!-- </div> -->
                  </Ddropzone>
                </DBox>
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="licence_invoice">
          <grow>
            <!-- <gcol>
              <gbox :title="$t('invoices_notification_header')" h="178px">
                <div class="invoice-notifications">
                  <div
                    style="
                      border-bottom: 1px solid var(--sprt-85);
                      height: 32px;
                    "
                  >
                    <div class="dt-checkbox-control" style="height: 31px">
                      <div class="dt-checkbox-label ut-colcen">
                        Notifications [ON/OFF]
                      </div>
                      <div class="ut-colcen">
                        <div class="dt-checkbox v2 s1">
                          <input
                            type="checkbox"
                            :name="'settings_invoices_notify_flag'"
                            :id="'settings_invoices_notify_flag'"
                            :checked="settings_invoices_notify_flag"
                            @click="
                              (e) =>
                                onInvoiceNotificationChange(
                                  'settings_invoices_notify',
                                  e
                                )
                            "
                          />
                          <div class="checkmark"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <TextField2
                    :id="'settings_invoices_notify'"
                    :placeholder="$t('send_to_mail_leave_for_default')"
                    :label="$t('send_to_mail_leave_for_default')"
                    :value="settings_invoices_notify"
                    @blur="onClientTextboxChange"
                    lw="220px"
                  />
                  <TextField2
                    :id="'settings_invoices_notify_days'"
                    :placeholder="$t('invoice_number_of_days')"
                    :label="$t('invoice_number_of_days')"
                    :value="client.settings_invoices_notify_days"
                    :textarea="false"
                    :height="52"
                    @blur="onClientTextboxChange"
                    bb="0px"
                    lw="220px"
                  />
                </div>
              </gbox>
            </gcol> -->
            <gcol>
              <gbox
                :title="$t('money_accounts')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.money_accounts &&
                      accountingSettingsData.money_accounts.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <DBox
                  v-if="accountingSettingsData"
                  :id="'cmp-settings-accounting-money-accounts'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add')} ${$t('money_account')}`"
                  @add_click="onAddNewMoneyAccount"
                >
                  <DList
                    :items="accountingSettingsData.money_accounts"
                    :primaryKey="'money_account_id'"
                    :labelKey="'money_account_name'"
                    :clickable="true"
                    @delete="onMoneyAccountDelete"
                    @item_click="onMoneyAccountClick"
                  />
                </DBox>
              </gbox>
            </gcol>
            <gcol></gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_account_settins_eu_one_stop_taxes">
          <grow>
            <gcol>
              <gbox
                :title="$t('vat_product_categories')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.vat_categories &&
                      accountingSettingsData.vat_categories.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <VatProductCategory
                  v-if="accountingSettingsData"
                  :accountingSettingsData="accountingSettingsData"
                  @delete="onVatProductCategoryDelete"
                  @onLoadDefault="onLoadDefaultClick"
                  @onVatReport="onVatReportClick"
                />
              </gbox>
              <gbox
                :title="$t('vat_territory')"
                :h="
                  boxHeight(
                    accountingSettingsData &&
                      accountingSettingsData.vat_territories &&
                      accountingSettingsData.vat_territories.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
              >
                <VatTerritory
                  v-if="accountingSettingsData"
                  :accountingSettingsData="accountingSettingsData"
                  @delete="onVatTerritoryDelete"
                />
              </gbox>
              <!-- <div class="ut-flex" style="margin-top:20px">
                <button
                  style="margin-left: 0px;flex:1"
                  class="dt-button v5 s8"
                  @click="onVatReportClick"
                >
                  {{ $t("Vat Report") }}
                </button>
                <button
                  style="margin-left: 0px;flex:1"
                  class="dt-button v5 s8"
                  @click="onLoadDefaultClick"
                >
                  {{ $t("Load Default") }}
                </button>
              </div> -->
            </gcol>
            <gcol>
              <gbox
                :title="$t('format')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      accountingSettingsData &&
                      accountingSettingsData.formats &&
                      accountingSettingsData.formats.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
              >
                <FormatComp
                  v-if="accountingSettingsData"
                  :accountingSettingsData="accountingSettingsData"
                  @change="onFormatChange"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_account_settings_ai_options">
          <grow>
            <gcol>
              <gbox :title="$t('invoice_reminder')" h="198px">
                <AIinvoiceReminder />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('invoices_notification_header')" h="178px">
                <div class="invoice-notifications">
                  <div
                    style="
                      border-bottom: 1px solid var(--sprt-85);
                      height: 32px;
                    "
                  >
                    <div class="dt-checkbox-control" style="height: 31px">
                      <div class="dt-checkbox-label ut-colcen">
                        {{$t('notifications')}} [{{
                          settings_invoices_notify_flag ? "ON" : "OFF"
                        }}]
                      </div>
                      <div class="ut-colcen">
                        <div class="dt-checkbox v2 s1">
                          <input
                            type="checkbox"
                            :name="'settings_invoices_notify_flag'"
                            :id="'settings_invoices_notify_flag'"
                            :checked="settings_invoices_notify_flag"
                            @click="
                              (e) =>
                                onInvoiceNotificationChange(
                                  'settings_invoices_notify',
                                  e
                                )
                            "
                          />
                          <div class="checkmark"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <TextField2
                    :id="'settings_invoices_notify'"
                    :placeholder="$t('send_to_mail_leave_for_default')"
                    :label="$t('send_to_mail_leave_for_default')"
                    :value="settings_invoices_notify"
                    @blur="onClientTextboxChange"
                    lw="220px"
                  />
                  <TextField2
                    :id="'settings_invoices_notify_days'"
                    :placeholder="$t('invoice_number_of_days')"
                    :label="$t('invoice_number_of_days')"
                    :value="client.settings_invoices_notify_days"
                    :textarea="false"
                    :height="52"
                    @blur="onClientTextboxChange"
                    bb="0px"
                    lw="220px"
                  />
                </div>
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <!-- Sidewindow -->
    <ModalContainer :modalKey="'moneyAccountForm'" :width="'small'">
      <MoneyAccountForm
        @cancelled="onModalCancelled"
        @done="onMoneyAccountSubmitted"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'costGroupForm'" :width="'small'">
      <CostGroupForm @cancelled="onModalCancelled" @done="onCostGroupDone" />
    </ModalContainer>
    <ModalContainer :modalKey="'incomeGroupForm'" :width="'small'">
      <CostGroupForm @cancelled="onModalCancelled" @done="onIncomeGroupDone" />
    </ModalContainer>

    <ModalContainer :modalKey="'channelForm'" :width="'small'">
      <ChannelForm @cancelled="onModalCancelled" @done="onChannelFormDone" />
    </ModalContainer>
    <ModalContainer :modalKey="'taxTypeForm'" :width="'small'">
      <TaxTypeForm @cancelled="onModalCancelled" @done="onTaxTypeModalDone" />
    </ModalContainer>
    <ModalContainer :modalKey="'addTaxGroup'" :width="'small'">
      <QuickModal
        :title="$t('add_tax_group')"
        :placeholder="'Tax Group Name'"
        @cancelled="onModalCancelled"
        @ok="onTaxGroupAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addVatTerritory'" :width="'small'">
      <AddVatTerritory
        @done="onVatTerritoryInsert"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editVatTerritory'" :width="'medium'">
      <EditVatTerritory
        @done="onVatTerritoryInsert"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'vatCategoryForm'" :width="'small'">
      <VatCategoryForm
        @addedOrEdited="onVatProductCategoryInsert"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'vatReport'" :width="'small'">
      <VatReportModal @cancelled="onModalCancelled" />
    </ModalContainer>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import QuickModal from "@plugins/quickmodal/quickmodal";
import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import { isValidEmail, JSONX } from "../../../../utility";
import { LoadingUI } from "@plugins/loading/loading";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import DTable from "@dtplugins/dtable/dtable";
import NTable from "@/plugins/datatable/datatable";
import Ddropzone from "@dtplugins/dbox/dropzone";

import MoneyAccountForm from "./money-account-form";
import CostGroupForm from "./cost-group-form";
import ChannelForm from "./channel-form";
import TaxTypeList from "./tax-types-list";
import TaxTypeForm from "./tax-type-form";
import TaxGroups from "./tax-groups";
import VatProductCategory from "./vat-product-category.vue";
import FormatComp from "./format.vue";
import VatTerritory from "./vat-territories.vue";
import AddVatTerritory from "./add-new-vat-territory-modal.vue";
import EditVatTerritory from "./edit-vat-territory-modal.vue";
import VatCategoryForm from "./vat-category-form.vue";
import VatReportModal from "./vat-report-modal.vue";
import AIinvoiceReminder from "./ai-invoice-reminder.vue";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { UPDATE_CLIENT } from "../../../../store/app/types";
import { accountingSettingsActions } from "../../store/accounting/actions";
import { dHeaders, DHeaderTypes } from "../../../../dt-plugins/dtable";
import { AccountingSettingsService } from "../../services/accounting-settings.service";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
export default {
  components: {
    DBox,
    DList,
    DTable,
    QuickModal,
    ModalContainer,
    LoadingUI,
    NTable,
    Ddropzone,

    MoneyAccountForm,
    CostGroupForm,
    ChannelForm,
    TaxTypeList,
    TaxTypeForm,
    TaxGroups,
    VatProductCategory,
    FormatComp,
    VatTerritory,
    AddVatTerritory,
    EditVatTerritory,
    VatCategoryForm,
    VatReportModal,
    AIinvoiceReminder,
  },
  mounted: function () {
    this.fetchData();
  },
  data: function () {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),

      selectedTaxGroup: null,
    };
    //MARK: Data Function
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("moneyAccountForm"),
    createModalMixin("costGroupForm"),
    createModalMixin("incomeGroupForm"),
    createModalMixin("channelForm"),
    createModalMixin("taxTypeForm"),
    createModalMixin("addTaxGroup"),
    createModalMixin("addVatTerritory"),
    createModalMixin("editVatTerritory"),
    createModalMixin("vatCategoryForm"),
    createModalMixin("vatReport"),
  ],
  computed: {
    ...mapGetters(["account"]),
    ...mapGetters(storeNS, {
      accountingSettingsData: "accountingSettingsData",
    }),
    accountingSettingsTabs: function () {
      return [
        {
          route: "accounting",
          value: this.$t("accounting"),
        },
        {
          route: "taxes",
          value: this.$t("taxes"),
        },
        {
          route: "licence_invoice",

          value: `${this.$t("licence_invoice")}s`,
        },
        {
          route: "tab_title_account_settins_eu_one_stop_taxes",
          value: this.$t("tab_title_account_settins_eu_one_stop_taxes"),
        },
        {
          route: "tab_title_account_settings_ai_options",
          value: this.$t("tab_title_account_settings_ai_options"),
        },
      ];
    },
    dropZoneInfo: function () {
      return this.selectedTaxGroup
        ? this.tax_group_items && this.tax_group_items.length > 0
          ? ""
          : this.$t('drag_and_drop_a_tax_type_here_to')
        : this.$t('select_a_tax_group_to_see_the');
    },
    tax_group_items: function () {
      return this.accountingSettingsData &&
        this.accountingSettingsData.tax_group_items
        ? this.accountingSettingsData.tax_group_items
        : [];
    },
    tax_group_items_loading: function () {
      return this.accountingSettingsData?.tax_group_items_loading || false;
    },
    taxGroupItemsTb: function () {
      return [
        createTableHeader("tax_name", { text: false }),
        createTableHeader("tax_rate_percent", { text: false }),
        createTableHeader("options", { text: false, mw: 35 }),
      ];
    },
    client: function () {
      return this.account?.client || {};
    },
    settings_invoices_notify_flag: function () {
      const csin = this.client?.settings_invoices_notify ?? "";
      return csin.length > 0 && csin != '0' ? true : false;
    },
    settings_invoices_notify: function () {
      return isValidEmail(this.client.settings_invoices_notify)
        ? this.client.settings_invoices_notify
        : "";
    },
    groupHeader: function () {
      return dHeaders([
        {
          text: "cost_group",
          value: "cost_group_name",
          selectable: true,
        },
        {
          text: "cluster",
          value: "cluster",
          type: DHeaderTypes.TextField,
          selectable: false,
        },
      ]);
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountingSettingsActions),
    // ...mapKeyToAction(storeNS, [
    //   ActionTypes.AccountingSettingsData.FETCH.ALL,
    //   ActionTypes.MoneyAccounts.INSERT.SINGLE,
    //   ActionTypes.MoneyAccounts.UPDATE.SINGLE,
    //   ActionTypes.MoneyAccounts.DELETE.SINGLE,
    //   ActionTypes.CostGroups.INSERT.SINGLE,
    //   ActionTypes.CostGroups.DELETE.SINGLE,
    //   ActionTypes.CostGroups.SET.SINGLE,
    //   ActionTypes.CostGroups.UPDATE.SINGLE,

    //   ActionTypes.Channels.INSERT.SINGLE,
    //   ActionTypes.Channels.FETCH.ALL,
    //   ActionTypes.Channels.UPDATE.SINGLE,
    //   ActionTypes.Channels.DELETE.SINGLE,

    //   ActionTypes.TaxTypes.INSERT.SINGLE,
    //   ActionTypes.TaxTypes.SET.SINGLE,
    //   ActionTypes.TaxTypes.UPDATE.SINGLE,
    //   ActionTypes.TaxTypes.DELETE.SINGLE,

    //   ActionTypes.TaxGroups.INSERT.SINGLE,
    //   ActionTypes.TaxGroups.FETCH.ALL,
    //   ActionTypes.TaxGroups.UPDATE.SINGLE,
    //   ActionTypes.TaxGroups.DELETE.SINGLE,

    //   ActionTypes.TaxGroupItems.INSERT.SINGLE,
    //   ActionTypes.TaxGroupItems.FETCH.ALL,
    //   ActionTypes.TaxGroupItems.UPDATE.SINGLE,
    //   ActionTypes.TaxGroupItems.DELETE.SINGLE
    // ]),
    dHeaders: dHeaders,
    createNTableConfig: createNTableConfig,
    fetchData: function () {
      this[ActionTypes.AccountingSettingsData.FETCH.ALL]();
    },
    tabSelectedRouting: function (tabId) {
      this.$router.push({
        name: "settings_accounting_tab",
        params: {
          tab: tabId,
        },
      });
    },
    onAddNewMoneyAccount: function () {
      openModalRoute(this, "money_account_form", {
        mode: "add",
      });
    },
    onMoneyAccountDelete: function (item) {
      this[ActionTypes.MoneyAccounts.DELETE.SINGLE](item);
    },
    onMoneyAccountClick: function ({ money_account_id }) {
      openModalRoute(this, "money_account_form", {
        mode: "edit",
        money_account_id,
      });
    },
    onModalCancelled: function () {
      console.log("this::");
      closeModalRoute(this, {
        mode: undefined,
        money_account_id: undefined,
        cost_group_id: undefined,
        channel_id: undefined,
        tax_type_id: undefined,
      });
    },
    onMoneyAccountSubmitted: async function ({ mode, money_account }) {
      if (mode == "add") {
        await this[ActionTypes.MoneyAccounts.INSERT.SINGLE](money_account);
        this.onModalCancelled();
      } else if (mode == "edit") {
        // console.log(ActionTypes.MoneyAccounts.UPDATE.SINGLE);
        await this[ActionTypes.MoneyAccounts.UPDATE.SINGLE](money_account);
        this.onModalCancelled();
      }
    },

    onCostGroupAddClick: function () {
      openModalRoute(this, "cost_group_form", {
        mode: "add",
      });
    },
    onCostGroupSelected: function ({ cost_group_id }) {
      openModalRoute(this, "cost_group_form", {
        mode: "edit",
        cost_group_id: cost_group_id,
      });
    },
    onCostGroupChange: function (payload) {
      this[ActionTypes.CostGroups.UPDATE.SINGLE]({
        ...payload,
        cg_type: "cost_groups",
      });
    },
    onCostGroupDone: async function ({ mode, cost_group }) {
      if (mode == "add") {
        await this[ActionTypes.CostGroups.INSERT.SINGLE]({
          ...cost_group,
          cg_type: "cost_groups",
        });
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.CostGroups.UPDATE.ALL]({
          ...cost_group,
          cg_type: "cost_groups",
        });
        this.onModalCancelled();
      }
    },
    onCostGroupDeleted: async function (cost_group) {
      const confirmationResult = await confirmDelete(
        "Cost Group",
        cost_group.cost_group_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.CostGroups.DELETE.SINGLE]({
          ...cost_group,
          cg_type: "cost_groups",
        });
      }
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Are you sure you want to delete the Cost Group ?",
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.CostGroups.DELETE.SINGLE]({
      //     ...cost_group,
      //     cg_type: "cost_groups",
      //   });
      // }
    },

    onIncomeGroupAddClick: function () {
      openModalRoute(this, "income_group_form", {
        mode: "add",
      });
    },
    onIncomeGroupChanged: function (payload) {
      const cg_type = "income_groups";
      this[ActionTypes.CostGroups.UPDATE.SINGLE]({ ...payload, cg_type });
    },
    onIncomeGroupSelected: function ({ cost_group_id }) {
      openModalRoute(this, "income_group_form", {
        mode: "edit",
        cost_group_id: cost_group_id,
      });
    },
    onIncomeGroupDone: async function ({ mode, cost_group }) {
      const cg_type = "income_groups";
      if (mode == "add") {
        await this[ActionTypes.CostGroups.INSERT.SINGLE]({
          ...cost_group,
          cg_type,
        });
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.CostGroups.SET.SINGLE]({
          ...cost_group,
          cg_type,
        });
        this.onModalCancelled();
      }
    },
    onIncomeGroupDeleted: async function (cost_group) {
      const confirmationResult = await confirmDelete(
        "Income Group",
        cost_group.cost_group_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.CostGroups.DELETE.SINGLE]({
          ...cost_group,
          cg_type: "income_groups",
        });
      }
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Are you sure you want to delete the Cost Group ?",
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.CostGroups.DELETE.SINGLE]({
      //     ...cost_group,
      //     cg_type: "income_groups",
      //   });
      // }
    },

    onNewChannelAddClick: function () {
      openModalRoute(this, "channel_form", {
        mode: "add",
      });
    },
    onChannelFormDone: async function ({ mode, channel }) {
      if (mode == "add") {
        await this[ActionTypes.Channels.INSERT.SINGLE](channel);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.Channels.UPDATE.SINGLE](channel);
        this.onModalCancelled();
      }
    },
    onChannelClick: function (channel) {
      openModalRoute(this, "channel_form", {
        mode: "edit",
        channel_id: channel.channel_id,
      });
    },
    onChannelDelete: async function (channel) {
      this[ActionTypes.Channels.DELETE.SINGLE](channel);
    },

    // Tax Type Methods
    onTaxTypeAddClick: function () {
      openModalRoute(this, "tax_type_form", {
        mode: "add",
      });
    },
    onTaxTypeEditClick: function ({ tax_type_id }) {
      openModalRoute(this, "tax_type_form", {
        mode: "edit",
        tax_type_id,
      });
    },
    onTaxTypeModalDone: async function ({ mode, tax_type }) {
      if (mode == "add") {
        await this[ActionTypes.TaxTypes.INSERT.SINGLE](tax_type);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.TaxTypes.SET.SINGLE](tax_type);
        this.onModalCancelled();
      }
    },
    onTaxTypeChange: function (payload) {
      this[ActionTypes.TaxTypes.UPDATE.SINGLE](payload);
    },
    onTaxTypeDeleteClick: async function (item) {
      // console.log(item);
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Are you sure you want to delete the Tax Type ?",
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.TaxTypes.DELETE.SINGLE](item);
      // }
      const confirmationResult = await confirmDelete("Tax Type", item.tax_name);
      if (confirmationResult === "OK") {
        this[ActionTypes.TaxTypes.DELETE.SINGLE](item);
      }
    },

    //Tax Group Methods
    onAddTaxGroupClick: function () {
      openModalRoute(this, "add_tax_group");
    },
    onTaxGroupAdded: async function (value) {
      await this[ActionTypes.TaxGroups.INSERT.SINGLE]({
        tax_group_name: value,
      });
      this.onModalCancelled();
    },
    onTaxGroupSelected: async function (tax_group) {
      this.selectedTaxGroup = tax_group;
      this[ActionTypes.TaxGroupItems.FETCH.ALL](tax_group);
    },
    onTaxGroupDelete: async function (taxGroup) {
      const confirmationResult = await confirmDelete(
        "Tax Group",
        taxGroup.tax_group_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.TaxGroups.DELETE.SINGLE](taxGroup);
      }
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Are you sure you want to delete the Tax Group ?",
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.TaxGroups.DELETE.SINGLE](taxGroup);
      // }
    },

    //Tax Group Item Methods
    onDeleteTaxGroupItem: async function (item) {
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: "Are you sure you want to delete the Tax Group Item ?",
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.TaxGroupItems.DELETE.SINGLE](item);
      // }
      const confirmationResult = await confirmDelete(
        "Tax Group Item",
        item.external_ref
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.TaxGroupItems.DELETE.SINGLE](item);
      }
    },
    onTaxGroupItemDrop: function (event) {
      event.preventDefault();

      const parseResult = JSONX.tryParse(event.dataTransfer.getData("text"));
      console.log("Log: parseResult", parseResult);

      if (!parseResult.success) {
        NotificationService.showNotification({
          text: "Please drop a valid Tax Type",
          timeout: 5000,
          type: "error",
        });
        return;
      }

      if (!this.selectedTaxGroup) {
        NotificationService.showNotification({
          text: "Please Select a Valid Tax Group before dropping an Tax Type",
          timeout: 5000,
          type: "error",
        });
        return;
      }

      const invoice_item = parseResult.result;

      this[ActionTypes.TaxGroupItems.INSERT.SINGLE]({
        ...parseResult.result,
        ...this.selectedTaxGroup,
      });
    },

    // Invoice Notifications
    onClientTextboxChange: function ({ name, value }) {
      switch (name) {
        case "settings_invoices_notify":
          if (value != "" && !isValidEmail(value)) {
            NotificationService.showNotification({
              text: "Please enter valid email, comma separated for multiple.",
              timeout: 5000,
              type: "error",
            });
            return;
          }

          value =
            value == "" &&
            document.getElementById("settings_invoices_notify_flag").checked
              ? "1"
              : value;
          break;

        default:
          break;
      }

      this.$store.dispatch(UPDATE_CLIENT, { name, value });
    },
    onInvoiceNotificationChange: function (name, event) {
      const value = event.target.checked;

      switch (name) {
        case "settings_invoices_notify":
          if (!value) {
            this.$store.dispatch(UPDATE_CLIENT, {
              name,
              value: "",
            });
          } else {
            this.$store.dispatch(UPDATE_CLIENT, {
              name,
              value: "1",
            });
          }
          break;

        default:
          break;
      }
    },

    onVatProductCategoryDelete: async function (item) {
      // const confirmationResult = await ConfirmationService.createP({
      //   subject: `${this.$t("delete_confirmation_msg_vat_category")}`,
      // });
      // if (confirmationResult == "OK") {
      //   this[ActionTypes.VatProductCategory.DELETE.SINGLE](item);
      //   //this[ActionTypes.TaxGroupItems.DELETE.SINGLE](item);
      // }
      const confirmationResult = await confirmDelete(
        "Vat Product Category",
        item.vat_category_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.VatProductCategory.DELETE.SINGLE](item);
      }
    },

    onFormatChange: function (payload) {
      this[ActionTypes.SettingsAccountFormat.UPDATE.SINGLE](payload);
    },
    onVatTerritoryInsert: function (payload) {
      this[ActionTypes.SettingsAccountVatTerritory.INSERT.SINGLE](payload);
      this.onModalCancelled();
    },

    onVatTerritoryDelete: function (item) {
      this[ActionTypes.SettingsAccountVatTerritory.DELETE.SINGLE](item);
    },

    onVatProductCategoryInsert: function (payload) {
      console.log("::::", payload);
      this[ActionTypes.VatProductCategory.INSERT.MULTIPLE](payload);
      this.onModalCancelled();
    },

    onVatReportClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "vat_report",
        },
      });
    },

    onLoadDefaultClick: async function () {
      //msg_confirmation_on_set_vat_default_entries
      //msg_default_vat_entry_can_not_be_created
      const countRes = await AccountingSettingsService.vatEntryCount();

      console.log(countRes);

      const entryCount = countRes.data.vat_entry_count;

      if (entryCount > 0) {
        const confirmationResult = await ConfirmationService.createP({
          subject: this.$t("msg_default_vat_entry_can_not_be_created"),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1", "s7"],
            }),
          ],
        });
      } else if (entryCount == 0) {
        const confirmationResult = await ConfirmationService.createP({
          subject: this.$t("msg_confirmation_on_set_vat_default_entries"),
          results: [
            createConfirmResult({
              value: "no",
              text: "Cancel",
            }),
            createConfirmResult({
              value: "ok",
              text: this.$t("understood_load_default"),
              classes: ["v1"],
            }),
          ],
        });

        if (confirmationResult == "ok") {
          await AccountingSettingsService.loadDefaultVatEntries();
          this.fetchData();
        }
      }
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-accounting-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 108px);
  }

  .dt-ntable {
    &.items-list {
      th {
        color: var(--text-5);
      }
    }
  }

  // .cost_group_name {
  // }

  .invoice-notifications {
    .fc2 {
      label {
        &.fc2-label {
          white-space: pre-wrap !important;
        }
      }
    }
    .dt-checkbox-control {
      padding-left: 3px;
      margin-top: 0px;
      .dt-checkbox {
        max-width: 40px;
        // margin-right: 10px;
        margin-left: 5px;
        // margin-top: 5px;
      }
      .dt-checkbox-label {
        padding-left: 3px;
        flex: 1;
        max-width: 238px;
        color: var(--text-5);
        white-space: nowrap;
        font-size: 13px;
      }
    }
  }
}

.cmp-settings-accounting-tax_group_items {
  height: 100%;
}
</style>
